export const XBIT_RELAY_TRANSFERS_PERMISSION_RESOURCE = 'xbit-relay:transfers';
export const XBIT_RELAY_TRANSFERS_READ_ACTION = 'read';
export const XBIT_RELAY_TRANSFERS_APPROVE_ACTION = 'approve';
export const XBIT_RELAY_TRANSFERS_REJECT_ACTION = 'reject';
export const XBIT_RELAY_TRANSFERS_RETRY_FAILED_ACTION = 'retry-failed';
export const XBIT_RELAY_TRANSFERS_CANCEL_FAILED_ACTION = 'cancel-failed';
export const XBIT_RELAY_TRANSFERS_MARK_DONE_ACTION = 'mark-done';

export const FAILED_ACTION_ELIGIBLE_PROVIDERS = ['INTERNAL_PERPETUAL', 'TAP_TRADING'] as const;

export const DEFAULT_TRANSFERS_PROVIDER = 'INTERNAL_PERPETUAL';

export const TRANSFER_STATUSES = [
  'Pending',
  'PendingAdminApproval',
  'Broadcasting',
  'Submitting',
  'Confirming',
  'Completed',
  'Failed',
  'Rejected',
] as const;

export const TRANSFER_PROVIDERS = [
  'PERPETUAL',
  'INTERNAL_PERPETUAL',
  'TAP_TRADING',
] as const;
